import { apiClient } from './api';

// User API endpoints
export const userService = {
  // Get all users
  getUsers: (params = {}) => {
    const searchParams = new URLSearchParams(params);
    return apiClient.get(`/users?${searchParams}`);
  },

  // Get user by ID
  getUserById: (id) => {
    return apiClient.get(`/users/${id}`);
  },

  // Create new user
  createUser: (userData) => {
    return apiClient.post('/users', userData);
  },

  // Update user
  updateUser: (id, userData) => {
    return apiClient.put(`/users/${id}`, userData);
  },

  // Partially update user
  patchUser: (id, userData) => {
    return apiClient.patch(`/users/${id}`, userData);
  },

  // Delete user
  deleteUser: (id) => {
    return apiClient.delete(`/users/${id}`);
  },

  // Get user profile
  getProfile: () => {
    return apiClient.get('/users/profile');
  },

  // Update user profile
  updateProfile: (profileData) => {
    return apiClient.put('/users/profile', profileData);
  },

  // Upload user avatar
  uploadAvatar: (file) => {
    const formData = new FormData();
    formData.append('avatar', file);
    
    return apiClient.post('/users/avatar', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // Search users
  searchUsers: (query, filters = {}) => {
    const params = { q: query, ...filters };
    const searchParams = new URLSearchParams(params);
    return apiClient.get(`/users/search?${searchParams}`);
  },

  // Get user statistics
  getUserStats: () => {
    return apiClient.get('/users/stats');
  },

  // Password reset methods
  requestPasswordReset: (email) => {
    return apiClient.post('/auth/password-reset/request', { email });
  },

  resetPassword: (token, newPassword) => {
    return apiClient.post('/auth/password-reset/reset', { token, newPassword });
  },

  validatePasswordResetToken: (token) => {
    return apiClient.get(`/auth/password-reset/validate?token=${token}`);
  },

  // Toggle user active status
  toggleUserActive: (id) => {
    return apiClient.patch(`/users/${id}/toggle-active`);
  },
};
